const appendLandingPageLayer = function ($selectedLayer) {
	const _$selectedLayer = $(`#${$selectedLayer}-layer`);
	const $landingPageLayerWrapper = $("#LandingPageLayerWrapper");
	positionLandingPageLayer();

	$landingPageLayerWrapper.append(_$selectedLayer);
};

const positionLandingPageLayer = function () {
	const _position = "left";
	const $oldLandingPageLayerWrapper = jQuery(".c-landingPage-login");
	$oldLandingPageLayerWrapper.wrap(jQuery('<div class="o-page-wrap u-p-none-m-down"></div>'));
	$oldLandingPageLayerWrapper.addClass(`c-landingPage-login--${_position}`);
};

export default appendLandingPageLayer;
